import { render, staticRenderFns } from "./pengajuan-skripsi.vue?vue&type=template&id=69bdfe16"
import script from "./pengajuan-skripsi.vue?vue&type=script&lang=js"
export * from "./pengajuan-skripsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports